import { useContext, useEffect, useState } from "react";
import { ModalSettingContext } from "../../../../index";
import s from './index.module.css';
import { timetableBeta } from "@/api";
import classNames from "classnames";
import CheckboxViolet from "@UI/New/ChecboxViolet/CheckboxViolet";
import Preloader from "@UI/Preloader";
import { CollapsePanel } from "../../../CollapsePanel";
 
export const UnavailableStudents = () => {
    const { state, toggleStudentInUnavailableStudents } = useContext(ModalSettingContext);
    
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(false);
    
    const getStudentsBygroups = () => {
        if(!state.groups[0]) {
            setStudents([]);
            return;
        }
        setLoading(true);
        timetableBeta.getStudentsBygroups({groups: state.groups})
            .then(({data}) => {
                if(data.status === 'success'){
                    setStudents(data.data);
                }
            })
            .finally(()=> setLoading(false))
    } 
    useEffect(getStudentsBygroups, [state.groups])

    return (
        <CollapsePanel header='Участники звонка'>
            <div className={classNames(s.studentsWrapper, 'customScroll')}>
                {
                    loading ? <Preloader /> : (
                        students?.map((statent) => (
                            <CheckboxViolet 
                                onClick={() => toggleStudentInUnavailableStudents(statent.value)}
                                value={!state.unavailableStudents.includes(statent.value)}
                                text={statent.label} />
                        ))
                    )
                }
            </div>
        </CollapsePanel>
                
    )
}
